import { setDraggable } from './drag-scrolling';

// Initialize the scroll through product hightlight products
var productHighlightSections = document.querySelectorAll(
  '.product-highlight-section'
);
for (let i = 0; i < productHighlightSections.length; i++) {
  initProductScroll(productHighlightSections[i]);
}

// Position blog post product hightlight embeds
const productHighlightEmbed = document.querySelectorAll(
  '.product-highlight-embed'
);
if (productHighlightEmbed.length > 0) {
  positionProductHighlightEmbed(productHighlightEmbed);
  window.addEventListener('resize', function () {
    positionProductHighlightEmbed(productHighlightEmbed);
  });
}

function initProductScroll(productHighlightSection) {
  const buttonRight = productHighlightSection.querySelector(
    '.scroll-button.button-right'
  );
  const buttonLeft = productHighlightSection.querySelector(
    '.scroll-button.button-left'
  );
  const productScroll =
    productHighlightSection.querySelector('.product-scroll');

  // Make horizontal product list scroll by dragging
  setDraggable({
    el: productScroll,
    startDrag: function () {
      buttonLeft.classList.add('d-none');
      buttonRight.classList.add('d-none');
    },
    endDrag: function () {
      buttonLeft.classList.remove('d-none');
      buttonRight.classList.remove('d-none');
    },
  });

  // Scroll product scroll view to left or right on button press
  if (buttonRight) {
    buttonRight.addEventListener('click', scroll.bind(undefined, 1));
  }
  if (buttonLeft) {
    buttonLeft.addEventListener('click', scroll.bind(undefined, -1));
  }
  function scroll(direction) {
    const scrollLeft = productScroll.scrollLeft + 930 * direction;
    productScroll.scrollTo(scrollLeft, 0);
    buttonLeft.classList.add('d-none');
    buttonRight.classList.add('d-none');
    setTimeout(() => {
      buttonRight.classList.remove('d-none');
      if (scrollLeft > 0) {
        buttonLeft.classList.remove('d-none');
      }
    }, 500);
  }
}

function positionProductHighlightEmbed(elements) {
  for (let i = 0; i < elements.length; i++) {
    elements[i].style.marginLeft = 0;
    var rect = elements[i].getBoundingClientRect();
    elements[i].style.marginLeft = `${-rect.left}px`;
    elements[i].style.width = `${document.body.clientWidth}px`;
  }
}
